<div class="spinner-container">
  <div class="spinner-icon-container" [style.width]="size + 'px'" [style.height]="size + 'px'" [style.padding]="padding + 'px'">
    <div class="spinner-icon" [style.width]="size + 'px'" [style.height]="size + 'px'"></div>
  </div>
</div>